import React, { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { TaskDescription } from '../components/TaskDescription.tsx';
import { TaskDescriptionParagraph } from '../components/TaskDescriptionParagraph.tsx';
import TaskDescriptionRoleRestrictions from '../components/TaskDescriptionRoleRestrictions.tsx';
import ShowMeButton from '../components/ShowMeButton.tsx';
import TaskCompleteButton from '../components/TaskCompleteButton.tsx';
import { EXPLORE_BASICS_TOUR_STEP_1_SPOTLIGHT_ID } from '../ui/spotlights/explore-basics/constants.tsx';
import { useActions, useCanManageViews } from '../services/index.tsx';
import { messages } from './exploreTheBasics.messages.tsx';
import { TASK_EXPLORE_THE_BASICS } from './constants.tsx';
import type { TaskDefinition } from './types.tsx';

const Description = () => {
	const { formatMessage } = useIntl();
	const canManageViews = useCanManageViews();
	const { setSpotlightStepId, navigateToAllIdeas } = useActions();

	const handleShowMeClick = useCallback(() => {
		navigateToAllIdeas();
		setSpotlightStepId(EXPLORE_BASICS_TOUR_STEP_1_SPOTLIGHT_ID);
	}, [navigateToAllIdeas, setSpotlightStepId]);

	return (
		<TaskDescription>
			<TaskDescriptionParagraph>{formatMessage(messages.description)}</TaskDescriptionParagraph>
			<TaskDescriptionRoleRestrictions description={formatMessage(messages.roleRestrictionsText)} />
			{canManageViews ? (
				<ShowMeButton onClick={handleShowMeClick} />
			) : (
				<TaskCompleteButton taskId={TASK_EXPLORE_THE_BASICS} />
			)}
		</TaskDescription>
	);
};

export const exploreTheBasics = {
	id: TASK_EXPLORE_THE_BASICS,
	title: messages.title,
	description: <Description />,
} satisfies TaskDefinition;
